import { Component } from '@angular/core';
import {Service} from "../../../../../Models/service";
import {ServiceService} from "../../../../../Services/service.service";
import {CategoryService} from "../../../../../Services/category.service";
import {Category} from "../../../../../Models/category";

@Component({
  selector: 'app-our-working-process',
  templateUrl: './our-working-process.component.html',
  styleUrls: ['./our-working-process.component.scss']
})
export class OurWorkingProcessComponent {
    CategoriesData: Category[] = [];

    constructor(private categoriesService: CategoryService) {
    }

    ngOnInit(): void {
        this.categoriesService.getAllCategories().subscribe(Categories => {
            this.CategoriesData = Categories;
        });
    }

}

